module.exports = __webpack_public_path__ + "img/file-earmark-image.8f4b5081.svg";